import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const fetch_data = async (parms) => {

    const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/sdms/SRC_Trans_Int`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(parms),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const SRC_Trans_Details = ({ month, year, src_no, heading }) => {
    const [beneficaryMemberList, setBeneficaryMemberList] = useState([]);
    const [benficaryEntitlementList, setBenficaryEntitlementList] = useState([]);
    const [benficaryAuthenticationsList, setBenficaryAuthenticationsList] = useState([]);
    const [benficaryTransList, setBenficaryTransList] = useState([]);

    const [benficaryEntitlementHeading, setBenficaryEntitlementHeading] = useState("");
    const [benficaryAuthenticationHeading, setBenficaryAuthenticationHeading] = useState("");
    const [benficaryTranscationHeading, setBenficaryTranscationHeading] = useState("");
    const [fpsStatus, setFpsStatus] = useState("");

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await fetch_data({ month, year, src_no });

                if (response_data) {
                    // data
                    setBeneficaryMemberList(response_data.beneficaryMemberList);
                    setBenficaryEntitlementList(response_data.benficaryEntitlementList);
                    setBenficaryAuthenticationsList(response_data.benficaryAuthenticationsList);
                    setBenficaryTransList(response_data.benficaryTransList);
                    // heading
                    setBenficaryEntitlementHeading(response_data.benficaryEntitlementHeading);
                    setBenficaryAuthenticationHeading(response_data.benficaryAuthenticationHeading);
                    setBenficaryTranscationHeading(response_data.benficaryTranscationHeading)

                    if (response_data.beneficaryMemberList && response_data.beneficaryMemberList.length > 0) {
                        try {
                            const fps_id = response_data.beneficaryMemberList[0].fps_id;
                            const fps_req = await fetch(`${process.env.REACT_APP_URL_FPS}/Common/getFpsStatus?fpsId=${fps_id}&month=${month}&year=${year}`, {
                                method: 'POST'
                            });
                            if (fps_req.ok) {
                                const fps_res = await fps_req.text();
                                try {
                                    const json = JSON.parse(fps_res);
                                    if (json && json.fps_status) setFpsStatus(json.fps_status);
                                    else if (Array.isArray(json) && json.length > 0 && json[0].fps_status) setFpsStatus(json[0].fps_status);
                                    else if (json && json.status) setFpsStatus(json.status);
                                    else if (Array.isArray(json) && json.length > 0 && json[0].status) setFpsStatus(json[0].status);
                                    else if (json && json.STATUS) setFpsStatus(json.STATUS);
                                    else if (Array.isArray(json) && json.length > 0 && json[0].STATUS) setFpsStatus(json[0].STATUS);
                                    else setFpsStatus(JSON.stringify(json).replace(/["{}]/g, ''));
                                } catch (e) {
                                    setFpsStatus(fps_res);
                                }
                            }
                        } catch (e) {
                            console.error("Error fetching fps status", e);
                        }
                    }

                } else {
                    setBeneficaryMemberList([]);
                    setBenficaryEntitlementList([]);
                    setBenficaryAuthenticationsList([]);
                    setBenficaryTransList([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, src_no]);

    if (loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}><br /><br /><Box sx={{ display: 'flex' }}>
            <CircularProgress />
        </Box></div>
    }

    let beneficaryMemberList_comp;
    let benficaryEntitlementList_comp;
    let benficaryAuthenticationsList_comp;
    let benficaryTransList_comp;



    if (beneficaryMemberList == null && benficaryEntitlementList == null && benficaryAuthenticationsList == null && benficaryTransList == null) {
        return <div class="mainhead" align="center">Details Not Found for Given RC ({src_no}) </div>;
    }


    if (beneficaryMemberList == null || beneficaryMemberList.length == 0) {
        beneficaryMemberList_comp = <>
            <div class="mainhead" align="center">Details Not Found for Given RC ({src_no}) </div>            <br /><br />
        </>
    } else {
        beneficaryMemberList_comp = <>

            <table align="center" width="80%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={17}>{'Member Details'} </th>
                    </tr>
                    <tr class="tableheader"><th colspan="7">
                        <font style={{ color: '#ff8000' }}>District</font>  : {beneficaryMemberList[0].dist_name_en} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <font style={{ color: '#ff8000' }}>Taluk</font>  :{beneficaryMemberList[0].afso_name_en}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <font style={{ color: '#ff8000' }}>FPS Id</font>  : {beneficaryMemberList[0].fps_id} {fpsStatus && <span>( <font style={{ color: '#ff8000' }}>Status</font> : {fpsStatus} )</span>}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                        <font style={{ color: '#ff8000' }}>Scheme</font>  : {beneficaryMemberList[0].scheme_short_name} </th></tr>
                    <tr className="tableheader">
                        <th>Sl.No</th><th>Member</th><th>Gender</th>
                        <th>Age</th>
                        {/* <!-- <th>Mobile</th> --> */}
                        <th>Status</th>
                        <th>UID</th>
                        <th>Verification<br />Status</th>
                    </tr>

                </thead>
                <tbody>
                    {
                        beneficaryMemberList.map((item, index) => (
                            <tr key={item.member_id}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td style={{ textAlign: 'left' }}>{item.member_name_en}</td>
                                <td style={{ textAlign: 'left' }}>{item.gender_type_gt_type_id}</td>
                                <td style={{ textAlign: 'right' }}>{item.member_age}</td>
                                <td style={{ textAlign: 'left' }}>{item.active}</td>
                                <td style={{ textAlign: 'left' }}>{item.uid}</td>
                                <td style={{ textAlign: 'left' }}>{item.kyc_uid}</td>
                            </tr>
                        ))
                    }

                </tbody>
            </table>
            <br />
            <br />
        </>
    }


    if (benficaryEntitlementList == null || benficaryEntitlementList.length == 0) {
        benficaryEntitlementList_comp = <>
        </>
    } else {
        benficaryEntitlementList_comp = <>
            <table align="center" width="80%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={17}>{'Entitlement for RC : '}{src_no}
                        </th>
                    </tr>
                    <tr className="tableheader">
                        {benficaryEntitlementList.map((item, index) => (
                            <td style={{ textAlign: 'center' }}>{item.comm_name_eng}({item.month_short_name}) <br />({item.unit_type})</td>
                        ))}
                    </tr>

                </thead>
                <tbody>
                    <tr > {benficaryEntitlementList.map((item, index) => (
                        <td style={{ textAlign: 'right' }}>{item.allocation_qty}</td>
                    ))}
                    </tr>
                </tbody>
            </table>
            <br /> <br />
        </>
    }

    if (benficaryAuthenticationsList == null || benficaryAuthenticationsList.length == 0) {
        benficaryAuthenticationsList_comp = <> </>
    } else {
        benficaryAuthenticationsList_comp = <>
            <table align="center" width="80%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={17}>{'Authentications for RC :'} {src_no} in {MonthC[month - 1]}'{year}

                        </th>
                    </tr>
                    <tr className="tableheader">
                        <td>Sl.No</td>
                        <td>FPS Id</td>
                        <td>Auth Type</td>
                        <td>Member</td>
                        <td>Error Code</td>
                        <td>Error Desc</td>
                        <td>Date</td>
                        <td>Total<br />Auth </td>
                    </tr> </thead>
                <tbody>
                    {benficaryAuthenticationsList.map((item, index) => (
                        <tr key={item.response_code}>
                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>{item.fps_id}</td>
                            <td style={{ textAlign: 'left' }}>{item.auth_type} </td>
                            <td style={{ textAlign: 'left' }}>{item.member_name_en} </td>
                            <td style={{ textAlign: 'right' }}>{item.response_code}</td>
                            <td style={{ textAlign: 'left' }}>{item.error_desc}</td>
                            <td style={{ textAlign: 'left' }}>{item.auth_time} </td>
                            <td style={{ textAlign: 'right' }}>{item.total} </td>

                        </tr>
                    ))
                    }

                </tbody>
            </table>
            <br />
            <br />
        </>
    }


    if (benficaryTransList == null || benficaryTransList.length == 0) {
        benficaryTransList_comp = <>
            <div className="mainhead" align="center">No Transaction Details Found</div>
        </>
    } else {
        benficaryTransList_comp = <>

            <table align="center" width="80%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={17}>{benficaryTranscationHeading}
                            <font style={{ color: '#ff8000' }}> </font>
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <td rowSpan={2}>Sl.No</td>
                        <td rowSpan={2}>Member</td>
                        <td rowSpan={2}>Availed<br />FPS</td>
                        <td rowSpan={2}>Allotted<br />Month</td>
                        <td rowSpan={2}>Allotted<br />Year</td>
                        <td rowSpan={2}>Avail. Date</td>
                        <td rowSpan={2}>Avail. Type</td>
                        <td colSpan={benficaryTransList[0].commoditylist.length}>Avail.Commodity</td>
                    </tr>
                    <tr className="tableheader">
                        {benficaryTransList[0].commoditylist.map((item, index) => (
                            <th >{item.comm_short}</th>
                        ))} </tr>
                </thead>
                <tbody>
                    {
                        benficaryTransList.map((item, index) => (
                            <tr key={item.availed_member_name}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td style={{ textAlign: 'left' }}>{item.availed_member_name}</td>
                                <td style={{ textAlign: 'left' }}>{item.port_fpsid}</td>
                                <td style={{ textAlign: 'left' }}>{MonthC[item.alot_month - 1]}</td>
                                <td style={{ textAlign: 'right' }}>{item.alot_year}</td>
                                <td style={{ textAlign: 'left' }}>{item.avail_date}</td>
                                <td style={{ textAlign: 'left' }}>{item.trans_status}</td>

                                {
                                    item.commoditylist.map((item1, index) => (
                                        <td style={{ textAlign: 'right' }}>{item1.allot_qty}</td>
                                    ))}

                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <br />
            <br />
        </>
    }

    if (error) {
        return <div className="mainhead" align="center">Internal error</div>;
    }

    return (
        <>

            {beneficaryMemberList_comp}

            {benficaryEntitlementList_comp}

            {benficaryAuthenticationsList_comp}

            {benficaryTransList_comp}

        </>
    );
};

export default SRC_Trans_Details;
